module.exports = __webpack_public_path__ + "img/close.446e8669.gif";